"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }


/* F4 (Rev 8): a new campaign is finished when its Message step is saved.
 * Until then it's an unfinished draft (no message, nothing queued or sent),
 * and opening it resumes the create wizard. Derived from the campaign itself,
 * so there's no extra state to store. */
 const isUnfinishedCampaign = (c) => {
  return !c.MessageTemplate.trim() && !exports.hasCampaignStarted.call(void 0, c)
}; exports.isUnfinishedCampaign = isUnfinishedCampaign

/* The campaign has queued or sent something, so an Add is gated (option 1).
 * A recipient waiting for consent was sent the consent request. */
 const hasCampaignStarted = (c) => {
  const { completed, queued, processing, failed } = c.Stats
  return completed + queued + processing + failed + (_nullishCoalesce(c.Stats.awaiting_consent, () => ( 0))) > 0
}; exports.hasCampaignStarted = hasCampaignStarted

/* Recipients that went out: sent, failed, or asked for consent first. */
 const campaignAttemptedCount = (s) =>
  s.completed + s.failed + (_nullishCoalesce(s.awaiting_consent, () => ( 0))); exports.campaignAttemptedCount = campaignAttemptedCount

 const campaignRecipientCount = (c) =>
  Object.values(c.Stats).reduce((a, b) => a + (_nullishCoalesce(b, () => ( 0))), 0); exports.campaignRecipientCount = campaignRecipientCount

/* Where an unfinished draft resumes: Message once recipients were added,
 * otherwise Recipients (Details is done once the draft exists). */
 const resumeStep = (c) =>
  exports.campaignRecipientCount.call(void 0, c) > 0 ? 'message' : 'recipients'; exports.resumeStep = resumeStep

/* Rev 27 P2: a campaign sent for later. The server has no start time on the
 * campaign; startAt is its first queued message's ScheduledAt. Until then it
 * is Scheduled; once the time passes it runs. Pausing unqueues it (Rev 33
 * T2), so a stopped campaign is never Scheduled. */


 const scheduleState = (
  c,
  startAt,
  now,
) => {
  const { queued, processing } = c.Stats
  if (!c.Active || !startAt || queued === 0 || processing > 0 || Date.parse(startAt) <= now) return null
  return 'scheduled'
}; exports.scheduleState = scheduleState

/* Rev 33 T2: Paused is the only stopped state. Pause returns everything not
 * yet sent to Not scheduled, so a paused campaign has sent something and has
 * something left; one stopped with messages still queued (paused by an older
 * client) is Paused too. Before anything goes out it's not yet sent. Waiting
 * for consent counts as gone out: the consent request was sent. */
 const isPausedCampaign = (c) => {
  const s = c.Stats
  if (c.Active) return false
  if (s.queued > 0) return true
  return exports.campaignAttemptedCount.call(void 0, s) + s.processing > 0 && s.not_scheduled + s.processing > 0
}; exports.isPausedCampaign = isPausedCampaign

/* Release review F-1: stopped with messages still queued and none not
 * scheduled, as an older client's Pause left it. Resume re-activates the
 * queued messages (StartCampaign with 0), since there's nothing to queue. */
 const isResumeQueuedOnly = (c) =>
  !c.Active && c.Stats.queued > 0 && c.Stats.not_scheduled === 0; exports.isResumeQueuedOnly = isResumeQueuedOnly
